export default function(ticketNumber) {
  if (!ticketNumber || ticketNumber.length < 4) return ticketNumber;

  return `${ticketNumber.substr(0, 3)}-${ticketNumber.substr(3)}`;
}
